export default __webpack_public_path__ + "static/media/login-update-icon.906e40ba.png";